<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>

<app-modal *ngIf="showModal" aria-labelledby="modal-title">
  <div class="close-modal">
    <a href="javascript:void(0)" aria-label="Fechar modal" alt="Fechar modal">
      <i class="fa fa-close" (click)="logout()"></i>
    </a>
  </div>

  <h1 class="titulo-page">Selecione um Perfil</h1>

  <div class="container-conviva form-registro modal-perfil">
    <div class="container-btns">

      <div *ngFor="let item of usuario?.perfis">
        <input
          type="button"
          class="btn_primary"
          value="{{item.descricaoPerfil}}"
          (click)="onClickPerfil(usuario.DadosUsuario[0].CodigoUsuario,item.codigoPerfil,item.codigoComportamento)"
        />
      </div>

    </div>
  </div>
</app-modal>


<app-modal *ngIf="showModalEscola" aria-labelledby="modal-escola-title">
  <form [formGroup]="formModalEscola" (submit)="SelecionarEscola()">
    <h1 class="titulo-page">Selecione uma escola</h1>

    <!-- FILTRO ESCOLA -->
    <section class="section-filtro busca-section-filtro">
      <div class="container">
        <!-- COMBO DIRETORIAS -->
        <div class="grupo-filter">
          <p><b>URE</b></p>
          <ng-select
            [items]="diretorias"
            bindLabel="nomeDiretoria"
            bindValue="codigoDiretoria"
            placeholder="Selecione uma URE"
            formControlName="codigoDiretoria"
            name="codigoDiretoria"
            (change)="getEscolas()"
            [ngClass]="{
              'is-invalid': resultPesquisa && form.codigoDiretoria.errors
            }"
            aria-describedby="diretorias-error"
          >
          </ng-select>
          <div
            *ngIf="resultPesquisa && form.codigoDiretoria.errors" class="alert">
            <div *ngIf="form.codigoDiretoria.errors.required">
              * URE é obrigatório
            </div>
          </div>

          <div class="grupo-filter-ano">
            <p><b>Atividade na URE</b></p>
            <label>
              <input type="checkbox" class="checkbox" (change)="checkedDiretoria()"/><i></i>
            </label>
          </div>
        </div>

        <!-- <div class="grupo-filter-checkbox">
          <p><b>D.E.</b></p>
          <input type="checkbox" [checked]="checkDiretoria" class="card-opcoes-chamado" id="soDiretoria" (change)="checkedDiretoria()"/>
        </div> -->

        <!-- COMBO ESCOLAS -->
        <div class="grupo-filter">
          <p><b>Escola</b></p>
          <ng-select
            [items]="escolas"
            bindLabel="nomeEscola"
            bindValue="codigoEscola"
            placeholder="Selecione uma Escola"
            formControlName="codigoEscola"
            name="codigoEscola"
            [ngClass]="{
              'is-invalid': resultPesquisa && form.codigoEscola.errors
            }"
            aria-describedby="escolas-error"
          >
          </ng-select>
          <div
            *ngIf="resultPesquisa && form.codigoEscola.errors" class="alert">
            <div *ngIf="form.codigoEscola.errors.required">
              * Escola é obrigatório
            </div>
          </div>
        </div>
      </div>
      <div class="container-btns-escola inline">
        <input
          type="button"
          (click)="FecharModalEscola()"
          class="btn_outline"
          value="Fechar" />
          <input
            type="submit"
            class="btn_primary"
            value="Selecionar" />
    </div>
    </section>
  </form>
</app-modal>

